import Image from 'next/image';
import React from 'react';

/**
 * 操作ガイドUIコンポーネントのプロパティ
 */
export interface OperationGuideProps {
  /** 表示するかどうか */
  visible: boolean;
  /** 閉じるボタンがクリックされたときのコールバック */
  onClose?: () => void;
}

/**
 * 操作ガイドUIコンポーネント
 *
 * 左下に表示される操作ガイドパネル。×ボタンで閉じることができる。
 */
export function OperationGuide({ visible, onClose }: OperationGuideProps) {
  // 固定スタイル設定
  const containerWidth = '375px';
  const containerLeft = '88px'; // InfoPanelと同じ左位置
  const containerBottom = '32px'; // InfoPanelと同じ位置
  const containerBorderRadius = '16px';

  const headerPadding = '10px 15px';
  const headerHeight = '44px';

  const closeButtonFontSize = '20px';
  const closeButtonLeft = '15px';

  const titleFontSize = '20px';

  const contentPadding = '24px';
  const instructionFontSize = '14px';
  const instructionMarginBottom = '16px';
  const instructionImageGap = '16px'; // 文章と画像の間隔

  if (!visible) {
    return null;
  }

  // 操作説明パネルを閉じる
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        bottom: containerBottom,
        left: containerLeft,
        width: containerWidth,
        backgroundColor: '#6D90CF',
        borderRadius: containerBorderRadius,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
        overflow: 'hidden',
        fontFamily: 'sans-serif',
        zIndex: 1002,
        color: 'white'
      }}
    >
      <div
        style={{
          position: 'relative',
          padding: headerPadding,
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          height: headerHeight
        }}
      >
        <button
          style={{
            position: 'absolute',
            left: closeButtonLeft,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            fontSize: closeButtonFontSize,
            cursor: 'pointer',
            padding: '0 5px',
            zIndex: 2,
            color: 'white'
          }}
          onClick={handleClose}
        >
          ×
        </button>
        <h3
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            margin: 0,
            fontSize: titleFontSize,
            fontWeight: 'bold',
            textAlign: 'center',
            zIndex: 1,
            color: 'white'
          }}
        >
          画面の操作方法
        </h3>
      </div>
      <div
        style={{
          padding: contentPadding,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div style={{ marginBottom: instructionMarginBottom, textAlign: 'center' }}>
          <div style={{ fontSize: instructionFontSize, marginBottom: instructionImageGap }}>
            <strong>視界回転</strong>：画面を<strong>ドラッグ</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Image alt='スワイプ操作' height={40} src='/illust_swipe.png' width={40} />
          </div>
        </div>

        <div style={{ marginBottom: instructionMarginBottom, textAlign: 'center' }}>
          <div style={{ fontSize: instructionFontSize, marginBottom: instructionImageGap }}>
            <strong>空間移動</strong>：<strong>キー</strong>か<strong>画面右下コントローラー</strong>で移動
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Image alt='WASDキー操作' height={55} src='/illsut_control.png' width={189} />
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: instructionFontSize }}>
            <strong>高さ変更</strong>：<strong>Q</strong>（上昇）/ <strong>E</strong>（下降）キー
          </div>
        </div>
      </div>
    </div>
  );
}
